export default {"src":"/blog/_next/static/media/star-navy.56c19e52.svg","height":9,"width":9};